import { ButtonIcon, ButtonText, Select } from "@visa/vds";
import Col from "@visa/vds/col";
import DataTable from "@visa/vds/data-table";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Icon from "@visa/vds/icon";
import Input from "@visa/vds/input";
import InputOption from "@visa/vds/input-option";
import PaginationWrapper from "@visa/vds/pagination-wrapper";
import Row from "@visa/vds/row";
import Tbody from "@visa/vds/tbody";
import Th from "@visa/vds/th";
import Thead from "@visa/vds/thead";
import Tr from "@visa/vds/tr";
import ButtonGroup from "antd/es/button/button-group";
import React, { useState } from "react";
import MCSSortableIcon from "./MCSSortableIcon";
import './_css/MCSPagedTable.css';

const MCSPagedTable = (props) => {
  const [typingTimeOut, setTypingTimeout] = useState({ name: "", timeout: 0 });

  const pageSize = props.pageSize ? props.pageSize : 10;
  const startCount = (props.selectedPage - 1) * pageSize + 1;
  const endCount = props.tableData
    ? (props.selectedPage - 1) * pageSize + props.tableData.length
    : 0;

  const handleSorting = (clickedHeader, orderable) => {
    if (orderable) {
      let descending = props.isDsc;

      if (clickedHeader == props.ordered) {
        descending = !descending;
        props.setDsc(descending);
      } else {
        descending = true;
        props.setOrdered(clickedHeader);
        props.setDsc(descending);
      }
      props.sortData(clickedHeader, descending);
    }
  };

  const handleManualSearch = (event) => {
    props.setSearchVal(event.target.value);
    if (event.key === "Enter") {
      event.preventDefault();
      props.handleSearchChange(event.target.value);
      clearTimeout(typingTimeOut.timeout);
    }
  };

  const handleAutoSearch = (searchValue) => {
    props.setSearchVal(searchValue);
    if (typingTimeOut.timeout) {
      clearTimeout(typingTimeOut.timeout);
    }
    setTypingTimeout({
      name: searchValue,
      timeout: setTimeout(function () {
        props.handleSearchChange(searchValue);
      }, 1500),
    });
  };

  const renderFilterBar = () => {
    return (
      <Col>
        <Form>
          <FormControl position="left" space="fifty">
            <Select
              label={props.filterBarLabel}
              defaultValue={props.filterBarDefaultValue}
              onChange={props.handleFilterBarChange}
            >
              {props.filterOptions &&
                props.filterOptions.map((option, key) => {
                  return (
                    <option key={key} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
            </Select>
          </FormControl>
        </Form>
      </Col>
    );
  };

  const renderSearchBar = () => {
    return (
      <Col
        className="mcs-paged-table-searchbar"
        alignEnd
        textAlign="right"
        noRightGutter={true}
      >
        <Form>
          <FormControl position="right">
            <Input
              name="search"
              value={props.searchVal}
              helpText={props.searchHelpText && props.searchHelpText}
              showHelpText
              onKeyPress={handleManualSearch}
              onChange={(e) => handleAutoSearch(e.target.value)}
              contentBeforeInput={
                <InputOption>
                  <Icon
                    className="vss-clickable-icon"
                    name="search"
                    resolution="low"
                  />
                </InputOption>
              }
            >
              {props.searchVal && (
                <InputOption>
                  <ButtonIcon
                    className="vss-clickable-icon"
                    ariaLabel="clear"
                    iconType="light-tiny"
                    resolution="low"
                    onClick={() => handleAutoSearch("")}
                  >
                    <Icon name="clear" resolution="tiny" />
                  </ButtonIcon>
                </InputOption>
              )}
            </Input>
          </FormControl>
        </Form>
      </Col>
    );
  };

  const renderBaseExportButton = (buttonText, handleOnClick) => {
    return (
      <Col className="padding-0px">
        <ButtonGroup
          className="button-group display-flex justify-content-flex-end"
        >
          <ButtonText disabled={false} onClick={handleOnClick}>
            {buttonText}
          </ButtonText>
        </ButtonGroup>
      </Col>
    );
  }

  const renderExportAllButton = () => {
    return renderBaseExportButton("Export All", props.handleExportAll)
  };

  const renderExportButton = () => {
    return renderBaseExportButton("Export", props.handleExport)
  };

  return (
    <>
      <Row>
        {props.useFilterBar && renderFilterBar()}
        <Col>
          <Row>
            {props.useExportAll && renderExportAllButton()}
            {props.useExport && renderExportButton()}
            {props.useSearchBar && renderSearchBar()}
          </Row>
        </Col>
      </Row>
      <DataTable size={props.size}>
        <Thead>
          <Tr>
            {props.colHeaders &&
              props.colHeaders
                .filter((x) => !x.hidden)
                .map((col, key) => (
                  <Th
                    className={col.orderable ? "vss-clickable-icon" : ""}
                    onClick={() => handleSorting(col.name, col.orderable)}
                    key={key}
                  >
                    <div>
                      {col && (
                        <>
                          <div
                            className="mcs-paged-table-col-header-text"
                          >
                            {col.displayName}
                          </div>
                          {props.colHeaders &&
                            col.orderable &&
                            col.orderable && (
                              <MCSSortableIcon
                                id={"sortable_" + col.name}
                                sortable={props.ordered === col.name}
                                dsc={props.isDsc}
                              />
                            )}
                        </>
                      )}
                    </div>
                  </Th>
                ))}
          </Tr>
        </Thead>
        <Tbody>{props.tableData}</Tbody>
      </DataTable>
      {props.tableData == null ||
        (props.tableData.length === 0 && (
          <Col>
            <span>No matching records found</span>
          </Col>
        ))}
      {props.tableData &&
        props.tableData.length !== 0 &&
        props.usePagination &&
        props.usePagination && (
          <>
            {props.totalCount > 0 && (
              <Row>
                <Col>
                  Showing {startCount} to {endCount} of {props.totalCount}{" "}
                  entries
                </Col>
              </Row>
            )}
            {(props.totalCount === undefined ||
              props.totalCount > pageSize) && (
              <Row>
                <Col>
                  <PaginationWrapper
                    ariaLabel="Paging for table"
                    onButtonClick={(e, page) => {
                      props.setSelectedPage(page);
                    }}
                    selectedPage={props.selectedPage}
                    totalPages={props.totalPages}
                  />
                </Col>
              </Row>
            )}
          </>
        )}
    </>
  );
};

export default MCSPagedTable;
